<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$tc("m.BT_" + betType, 2)')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :placeholder='$t("ui.member_id")'
                    v-model="member_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.bet_type')" size="sm")
                  b-form-select(
                    ref="bet_type"
                    v-model="bet_type"
                    :options="$helpers.getBetType()"
                    size="sm"
                    :disabled="loading"
                    @change="search"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.timer')" size="sm")
                  b-form-select(
                    ref="refresh"
                    v-model="refresh"
                    :options="refreshOptions"
                    size="sm"
                    :disabled="loading"
                    @change="refreshTimer"
                  )
              .col-sm-12.col-md-6.col-lg-2.col-xl-2.mb-1
                b-input-group(:prepend='$t("ui.type")' size="sm")
                  label.type-switch.type-switch-label.type-switch-success.mb-0
                    input(type="checkbox" class="type-switch-input" v-model="full_amount" :disabled="loading")
                    span(class="type-switch-slider" :data-checked="$t('ui.full')" :data-unchecked="$t('ui.half')")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="$t('ui.refresh') + (refresh > 0 ? ' (' +  timer + ' ' + $t('ui.seconds') + ')' : '')" isModal=false type="button" @click="search")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="search")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="betList" :fields="fields" :per-page="perPage" :filter="filter")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(bet_time)="row")
                    span {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
                    br
                    span #[b {{ row.item.bet_id }}]
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(event)="row")
                    template(v-if="row.item.bet_type == 'PARLAY'")
                      span(v-if="row.item.bet_type_share == 'PARLAYMMO'") #[b {{ $t("ui.mmo_parlay") }}]
                      span(v-else) #[b {{ $t("ui.mix_parlay") }}]
                        div
                          span.mr-1 {{ row.item.bet_member }} @
                          span {{ row.item.odds_display_bet }}
                    template(v-else)
                      div
                        span #[b {{ getName(row.item.league_id, 0) }}]
                      div(v-if="row.item.home_team_name != null")
                        span.mr-1(:class="$helpers.getTeamClass(row.item, 0)") {{ getName(row.item.match_id, 1) }}
                        span.mr-1 vs
                        span.mr-1(:class="$helpers.getTeamClass(row.item, 1)") {{ getName(row.item.match_id, 2) }}
                      div
                        span.mr-1 {{ $moment(row.item.match_time).format("YYYY-MM-DD") }}
                        span(v-if="isLiveMarket(row.item)") ({{ row.item.home_running_score}} - {{ row.item.away_running_score }})
                  template(v-slot:cell(detail)="row")
                    template(v-if="row.item.bet_type == 'PARLAY'")
                      span @ {{ row.item.odds_display }}
                      div
                        span.label.bg-black {{ $t("ui.details") }}
                        template(v-if="row.item.bet_type_share == 'PARLAYMMO'")
                          i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetailMMO(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                        template(v-else)
                          i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetail(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                    template(v-else)
                      div.mb-1
                        //- span.label.bg-black #[b {{ $tc("m.BT_" + row.item.bet_type, 2) }}]
                        span.label.bg-black #[b {{ getBetType(row.item) }}]
                      div
                        span(:class="$helpers.getBetClass(row.item)") {{ $helpers.getBetDetail(row.item, getName(row.item.match_id, 1), getName(row.item.match_id, 2)) }}
                      div
                        // span {{ row.item.agent_pt }} x {{ row.item.bet_member }}
                        // br
                        span.mr-1 {{ $helpers.getDisplayBall(row.item) }} @
                        span #[b {{ row.item.odds_display }}] {{ $helpers.getOddsType(row.item) }}
                        //- span ({{ getOddsType(row.item.odds_type) }})
                  template(v-slot:row-details="row")
                    b-table#innerTable.table-sm(show-empty :items="parlayList" :fields="vDfields")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(working_date)="row")
                        span {{ $moment(row.item.working_date).format("YYYY-MM-DD HH:mm:ss") }}
                      template(v-slot:cell(league_name)="row")
                        span {{ getParlayName(row.item.league_id, 0) }}
                      template(v-slot:cell(home_team_name)="row")
                        span(:class="row.item.home_giving == 1 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 1) }}
                      template(v-slot:cell(away_team_name)="row")
                        span(:class="row.item.home_giving == 0 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 2) }}
                      template(v-slot:cell(full_half)="row")
                        span {{ (row.item.full_half == 1) ? $t("ui.full_time") : $t("ui.half_time") }}
                      template(v-slot:cell(running_score)="row")
                        span {{ row.item.running_score ? row.item.running_score : '-' }}
                      template(v-slot:cell(status)="row")
                        template(v-if="isMMO")
                          span {{ $helpers.showWinStatusMMO(row.item) }}
                        template(v-else)
                          span {{ $helpers.showWinStatus(row.item) }}
                  template(v-slot:cell(bet_amount)="row")
                    span(:class="$helpers.getNumberClass(getBetAmount(row.item))") #[b {{ getBetAmount(row.item) | currency }} ]
</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    betType: {
      type: String,
      default: "ALL"
    }
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      betList: [],
      parlayList: [],
      isMMO: false,
      refreshOptions: [
        { value: 0, text: this.$t("ui.no_refresh") },
        { value: 15, text: 15 + ' ' + this.$t("ui.seconds") },
        { value: 30, text: 30 + ' ' + this.$t("ui.seconds") },
        { value: 45, text: 45 + ' ' + this.$t("ui.seconds") },
        { value: 60, text: 60 + ' ' + this.$t("ui.seconds") }
      ],
      bet_type: this.betType,
      member_id: this.$store.getters.getSelectedID == this.$store.getters.accountID ? "" : this.$store.getters.getSelectedID,
      full_amount: true,
      filter: null,
      sortBy: "bet_time",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      countdown: null,
      timer: 15,
      refresh: 0,
      match: [],
      league: [],
      matchParlay: [],
      leagueParlay: []
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_time",
          label: this.$t("ui.date_time"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "25%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_amount",
          label: this.$t("ui.amount"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    vDfields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "working_date",
          label: this.$t("ui.date"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "full_half",
          label: this.$t("ui.match_time"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet_type",
          label: this.$t("ui.bet_type"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "odds_display",
          label: this.$t("ui.odds_display"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "payout_odds",
          label: this.$t("ui.payout"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_score",
          label: this.$t("ui.home_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_score",
          label: this.$t("ui.away_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "running_score",
          label: this.$t("ui.running_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted: function() {
    this.search()
    this.countdown = setInterval(() => {
      if(this.refresh > 0) {
        if(this.timer > 0) {
          this.timer -= 1
        } else {
          this.timer = this.refresh
          this.search()
        }
      }
    }, 1 * 1000)
  },
  beforeDestroy: function() {
    clearInterval(this.countdown)
  },
  methods: {
    getBetType(item) {
      let type = item.bet_type
      let share = item.bet_type_share

      if(type == 'HDP' && share == 'HDPMMO') {
        return this.$tc("m.BT_HDPMMO")
      }

      if(type == 'OU' && share == 'HDPMMO') {
        return this.$tc("m.BT_OUMMO")
      }

      return this.$tc("m.BT_" + type, 2)
    },
    refreshTimer() {
      this.timer = this.refresh
      this.search()
    },
    getBetAmount: function(item) {
      if(this.full_amount) {
        return item.bet_member
      } else {
        return item.bet_agent
      }
    },
    isLiveMarket: function(item) {
      return item.market_type == 3 && (item.bet_type == 'HDP' || item.bet_type == 'HDPH' || item.bet_type == 'OU' || item.bet_type =='OUH')
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.search()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.search()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    getParlayName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.leagueParlay.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.matchParlay.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    search: function() {
      if (!this.$v.$invalid) {
        let url = (this.bet_type != "ALL") ? "user/getActiveBetlistBetType" : "user/getActiveBetlistAll"
        let bet_type = this.bet_type
        let member_id = this.member_id
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch(url, { bet_type, member_id, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.totalRows = 0
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.betList = response.data
                this.match = response.names.match
                this.league = response.names.league
                this.totalRows = response.data.length > 0 ? this.betList[0]["totalrows"] : 0
              } else {
                this.betList = []
                this.totalRows = 0
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.betList = []
            this.totalRows = 0
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    getParlayDetail: function(item) {
      this.isMMO = false
      this.parlayList = []
      if(item._showDetails) {
        this.betList.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
      let bet_id = item.bet_id
      this.$store
        .dispatch("user/getParlayDetail", { bet_id })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    getOddsType(oddstype){
      return config.oddsType[oddstype];
    },
    getParlayDetailMMO: function(item) {
      this.isMMO = true
      this.parlayList = []
      if(item._showDetails) {
        this.betList.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
      let bet_id = item.bet_id
      this.$store
        .dispatch("user/getMMOParlayDetail", { bet_id })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    }
  }
};
</script>
